export default function AddToCart({ title, onClick }) {
    return (
            <button
                type="button"
                className="esc-ii-w-full esc-ii-py-5 esc-ii-rounded esc-ii-border-2 esc-ii-border-black esc-ii-mt-3"
                onClick={onClick}
            >
                <span className="esc-ii-uppercase">{title}</span>
            </button>
    );
}
